import script from "./BannersManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./BannersManagement.vue?vue&type=script&setup=true&lang=js"

import "./BannersManagement.vue?vue&type=style&index=0&id=df4625fc&scoped=true&lang=css"
import "./BannersManagement.vue?vue&type=style&index=1&id=df4625fc&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df4625fc"]])

export default __exports__